import { render } from "./item-modal.vue?vue&type=template&id=4bc2d46c&scoped=true"
import script from "./item-modal.vue?vue&type=script&lang=js"
export * from "./item-modal.vue?vue&type=script&lang=js"

import "./item-modal.vue?vue&type=style&index=0&id=4bc2d46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc2d46c"]])

export default __exports__